import React, { useState } from "react";
import { Button as CustomBtn } from "../../ui";
import { toast } from "react-toastify";
import { Input } from "../../ui";
import Modal from "react-modal";
import { useTheme } from "../context/ThemeContext";

import {
  useCreateVoteMutation,
  useFetchAllActiveBannersQuery,
} from "../../store/api/apiSlice";
const VoteSection = () => {
  const { data: bannersData = { banners: [] }, refetch } =
    useFetchAllActiveBannersQuery();
  const { fgColor, bgColor } = useTheme();
  const [createVote] = useCreateVoteMutation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [voteLoader, setVoteLoader] = useState(false);

  const [selectedBannerId, setSelectedBannerId] = useState(null);
  const [selectedVoteTitle, setSelectedVoteTitle] = useState("");
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const [feedback, setFeedback] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user ? user._id : null;
  const handleVote = async (bannerId, voteFor) => {
    setVoteLoader(true);
    try {
      const voteData = {
        userId,
        bannerId,
        voteFor,
        voteFeedback: feedback,
      };
      const response = await createVote(voteData).unwrap();

      setVoteLoader(false);
      toast.success("Voted successfully!");
      setIsModalOpen(false);
      setFeedback("");
    } catch (error) {
      setVoteLoader(false);

      if (error?.data?.message === "Vote already exist") {
        toast.error("Vote Already Exist");
      } else {
        toast.error("Vote is Required");
      }
    }
  };

  const closeSupportModal = () => {
    setIsSupportModalOpen(false);
  };
  const openModal = (latestBanner) => {
    setSelectedBannerId(latestBanner);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedBannerId(null);
    setSelectedVoteTitle("");
  };
  return (
    <div>
      <div>
        <div
          className="card "
          id="football"
          style={{ backgroundColor: bgColor, color: fgColor }}
        >
          <div className="card-body voteSection_container" >
            {bannersData.banners.length > 0 &&
              (() => {
                const latestBanner = [...bannersData.banners].sort(
                  (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                )[0];

                return (
                  <div className="banners-active-cont" key={latestBanner._id}>
                    <div style={{ color: fgColor }}>
                      <h4 className="csfatext" style={{ color: fgColor }}>
                        {latestBanner.title}
                      </h4>
                      <p className="csfatextp" style={{ color: fgColor }}>
                        Please vote on the latest {latestBanner.narrative}
                      </p>
                    </div>
                    <div className="row " style={{ color: fgColor }}>
                      {latestBanner.type === "Poll" && (
                        <button
                          className="btn btn-light w-100"
                          style={{ color: fgColor }}
                          onClick={() => {
                            openModal(latestBanner._id);
                          }}
                        >
                          Vote
                        </button>
                      )}
                      {latestBanner.type === "Survey" && (
                        <button
                
                          className="btn btn-light2 w-100 voteSection_Suport_btn"
                          onClick={() => {
                            openModal(latestBanner._id);
                          }}
                        >
                          Support
                        </button>
                      )}
                      {latestBanner.type === "Other" && (
                        <button
                          style={{
                           
                            color: fgColor,
                          }}
                          className="btn btn-light2 w-100 voteSection_Submit_btn"
                          onClick={() => {
                            openModal(latestBanner._id);
                          }}
                        >
                          Submit
                        </button>
                      )}
                    </div>
                  </div>
                );
              })()}
            {bannersData.banners.length === 0 && (
              <p>No active banners found.</p>
            )}
          </div>
        </div>

        <Modal
          isOpen={isSupportModalOpen}
          onRequestClose={closeSupportModal}
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.75)",
              zIndex: 1000,
            },
            content: {
              position: "absolute",
              backgroundColor: "white",
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
              padding: "20px",
              borderRadius: "8px",
              width: "max-content",
            },
          }}
        >
          <div
           className="voteSection_Modal"
          >
            <h4 style={{ margin: 0 }}>Support</h4>
            <button
              onClick={closeSupportModal}
              className="voteSection_Modal_btn"
            >
              &times;
            </button>
          </div>

          <hr className="voteSection_Modal_divider" />

          <h4>College sport fan Assosciate</h4>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
            <br />
            Lorem Ipsum has been the industry's standard dummy text ever since
            the 1500s,
          </p>

          <div className="voteSection_Modal_Isupport">
            <button
             className="voteSection_Modal_Isupport_btn"
              onClick={() => {
                closeSupportModal();
              }}
            >
              I Support
            </button>
          </div>
        </Modal>
        {bannersData.banners.length > 0 &&
          bannersData.banners.map((banner) => (
            <Modal
              key={banner._id}
              isOpen={isModalOpen && selectedBannerId === banner._id}
              onRequestClose={closeModal}
              style={{
                overlay: {
                  backgroundColor: "rgba(0, 0, 0, 0.75)",
                  zIndex: 1000,
                },
                content: {
                  position: "absolute",
                  backgroundColor: "white",
                  top: "50%",
                  left: "50%",
                  right: "auto",
                  bottom: "auto",
                  marginRight: "-50%",
                  transform: "translate(-50%, -50%)",
                  padding: "20px",
                  borderRadius: "8px",
                  maxWidth: 600,
                },
              }}
            >
              <div
                className="voteSection_VoteFor"
              >
                <h4 style={{ margin: 0 }}>{banner.title}</h4>
                <button
                  onClick={closeModal}
                  className="voteSection_VoteFor_btn"
                >
                  &times;
                </button>
              </div>

              <hr className="voteSection_VoteFor_divider2"/>

              <p>{banner.narrative}</p>

              <h5 className="pt-3">Please vote on the latest :</h5>
              <div
               className="voteSection_VoteFor_MainDiv"
              >
                {banner.voteTitles && banner.voteTitles.length > 0
                  ? (() => {
                      try {
                        const titles = JSON.parse(banner.voteTitles[0]);
                        return titles.slice(0, 5).map((title, index) => (
                          <div className="voteSection_VoteFor_selectVote">
                            <input
                              type="radio"
                              name="voteOption"
                              value={title}
                              onChange={() => setSelectedVoteTitle(title)}
                              style={{
                                marginRight: "8px",
                                marginLeft: "8px ",
                                accentColor: "#ce1126",
                              }}
                            />
                            <div>
                              <span
                                className="voteSection_VoteFor_selectVote_span"
                              >
                                {title}
                              </span>
                            </div>
                          </div>
                        ));
                      } catch (error) {
                        return null;
                      }
                    })()
                  : null}
              </div>

              {banner.enableFeedback ? (
                <Input
                  placeholder="Feedback"
                  label="Feedback"
                  type="text"
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                  className="voteSection_VoteFor_selectVote_input"
                />
              ) : null}
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <CustomBtn
                  loading={voteLoader}
                  style={{
                    backgroundColor: "#ce1126",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    marginTop: "20px",
                  }}
                  onClick={() => handleVote(banner._id, selectedVoteTitle)}
                >
                  Vote
                </CustomBtn>
              </div>
            </Modal>
          ))}
      </div>
    </div>
  );
};

export default VoteSection;
